const SendIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
            <circle cx="19" cy="19" r="19" fill="#766699"/>
            <path d="M16 12L22.3694 18.1938C22.4108 18.234 22.4437 18.2817 22.4661 18.3342C22.4885 18.3868 22.5 18.4431 22.5 18.5C22.5 18.5569 22.4885 18.6132 22.4661 18.6658C22.4437 18.7183 22.4108 18.766 22.3694 18.8062L16 25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default SendIcon;